import { UserConfiguration } from "@app/core/user/domain/user-configuration";
import { UserConfigurationDB } from "@app/core/user/data/local/user-configuration-db";
import { Language } from "@app/core/user/domain/language";

export class UserConfigurationDBMapper {
  private static readonly KEY_CATALAN = "ca";
  private static readonly KEY_SPANISH = "es";
  private static readonly KEY_ENGLISH = "en";
  private static readonly KEY_FRENCH = "fr";
  private static readonly KEY_GERMAN = "de";
  private static readonly KEY_ITALIAN = "it";
  private static readonly KEY_NETHERLANDS = "nl";
  private static readonly KEY_PORTUGUESE = "pt";
  private static readonly KEY_RUSSIAN = "ru";
  private static readonly KEY_HEBREW = "he";
  private static readonly KEY_ARABIC = "ar";

  static fromEntity(userConfiguration: UserConfiguration): UserConfigurationDB {
    const language = this.languageSerialize(
      userConfiguration.language as Language
    );
    return {
      language: language,
      units: userConfiguration.units!,
      hasChat: userConfiguration.hasChat,
    };
  }

  static toEntity(configuration: UserConfigurationDB): UserConfiguration {
    const language = this.languageDeserialize(configuration.language);
    return new UserConfiguration({
      language: language,
      units: configuration.units,
      hasChat: configuration.hasChat ?? false,
    });
  }

  private static languageDeserialize(language: string): Language | null {
    switch (language) {
      case this.KEY_CATALAN:
        return Language.CATALAN;
      case this.KEY_SPANISH:
        return Language.SPANISH;
      case this.KEY_ENGLISH:
        return Language.ENGLISH;
      case this.KEY_FRENCH:
        return Language.FRENCH;
      case this.KEY_GERMAN:
        return Language.GERMAN;
      case this.KEY_ITALIAN:
        return Language.ITALIAN;
      case this.KEY_NETHERLANDS:
        return Language.NETHERLANDS;
      case this.KEY_PORTUGUESE:
        return Language.PORTUGUESE;
      case this.KEY_RUSSIAN:
        return Language.RUSSIAN;
      case this.KEY_HEBREW:
        return Language.HEBREW;
      case this.KEY_ARABIC:
        return Language.ARABIC;
      default:
        return null;
    }
  }

  private static languageSerialize(language: Language): string {
    switch (language) {
      case Language.CATALAN:
        return this.KEY_CATALAN;
      case Language.SPANISH:
        return this.KEY_SPANISH;
      case Language.ENGLISH:
        return this.KEY_ENGLISH;
      case Language.FRENCH:
        return this.KEY_FRENCH;
      case Language.GERMAN:
        return this.KEY_GERMAN;
      case Language.ITALIAN:
        return this.KEY_ITALIAN;
      case Language.NETHERLANDS:
        return this.KEY_NETHERLANDS;
      case Language.PORTUGUESE:
        return this.KEY_PORTUGUESE;
      case Language.RUSSIAN:
        return this.KEY_RUSSIAN;
      case Language.HEBREW:
        return this.KEY_HEBREW;
      case Language.ARABIC:
        return this.KEY_ARABIC;
    }
  }
}
